import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-order-detail',
  standalone: false,
  
  templateUrl: './sales-order-detail.component.html',
  styles: ``
})
export class SalesOrderDetailComponent {

}
